import { isNil, isPlainObject, mapValues, omit, omitBy } from 'lodash';

export interface QuestionType {
  name: string;
  heading: string;
}

const isEmptyValue = (value: unknown) =>
  isNil(value) || value === '' || value === false;

// Makes the unsaved-changes check ignore differences that aren't edits:
// emptying a field leaves '' (or switching a flag back off leaves false)
// where the original had no value, and ValidatedInput tags every table row
// (e.g. options) with a render-only jsonPath that TableEditor then echoes
// back on change.
export const normalizeForComparison = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(normalizeForComparison);
  }
  if (isPlainObject(value)) {
    return mapValues(
      omitBy(omit(value as object, 'jsonPath'), isEmptyValue),
      normalizeForComparison
    );
  }
  return value;
};
